import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  usage: string
  isOpen: boolean
  onClose: () => void
}

/** 遊び方ダイアログ */
export const DialogCampaignHowToPlay = memo(({ usage, isOpen, onClose }: Props) => {
  const { t } = useTranslation()
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('how_to_play.how_to_play', '遊び方')}>
      <HtmlContent html={usage} variant="body1" className="mt-4 text-gray-700 whitespace-pre-wrap" />
    </Dialog>
  )
})
